export type { Theme } from './types';
export { crtDarkTheme } from './crt';
export { crtLightTheme } from './crtLight';
export { cleanDarkTheme } from './default';
export { cleanLightTheme } from './cleanLight';
export { highContrastTheme } from './highContrast';

import { crtDarkTheme } from './crt';
import { crtLightTheme } from './crtLight';
import { cleanDarkTheme } from './default';
import { cleanLightTheme } from './cleanLight';
import { highContrastTheme } from './highContrast';

export const themes = {
  'crt-dark': crtDarkTheme,
  'crt-light': crtLightTheme,
  'clean-dark': cleanDarkTheme,
  'clean-light': cleanLightTheme,
  'high-contrast': highContrastTheme,
} as const;
